/** Dutch translations for the dashboard mapping element wizard */
import { WizardConfig } from '../translations-types';

const translations: WizardConfig = {
  whatToShow: 'Wat wil je tonen?',
  chooseImage: 'Kies afbeelding',
  labelSettings: 'Label instellingen',
  advanced: 'Instellen antwoorden',
  selectQuestionnaire: 'Selecteer een vragenlijst',
  selectQuestion: 'Selecteer een vraag',
  persistentMode: 'Vaste tekst/afbeelding',
  persistentModeDescription: 'Toon altijd een vaste tekst en/of afbeelding.',
  noImage: 'Geen afbeelding',
  refineElement: 'Wil je dit element verder verfijnen?',
  addCondition: 'Toon alleen bij een bepaald antwoord',
  conditionValue: 'Voorwaarde waarde',
  addVariant: 'Variant toevoegen',
  variant: 'Variant',
  back: 'Terug',
  nextVariant: 'Volgende variant',
  variantExplanation: 'Maak varianten om een ander plaatje of label te tonen op basis van het antwoord op de vraag.',
  variants: 'Varianten',
  answer: 'Antwoord',
  addAnotherAnswer: 'Wil je nog een antwoord configureren?',
  showForEveryAnswer: 'Afbeelding tonen bij elk antwoord',
  showForSpecificAnswer: 'Afbeelding tonen bij een specifiek antwoord',
  questionTypeText: 'Vrij tekstveld',
  questionTypeNumber: 'Getalinvoer',
  questionTypeRating: 'Score 1-10',
  questionTypeDate: 'Datuminvoer',
  questionConfiguration: 'Vraagconfiguratie',
  changeQuestionWarningTitle: 'Vraag wijzigen?',
  changeQuestionWarningMessage:
    'Je hebt al antwoorden geconfigureerd voor deze vraag. Als je de vragenlijst of vraag wijzigt, worden alle ingestelde antwoorden verwijderd. Wil je doorgaan?',
};

export default translations;
